import React, { Fragment } from 'react';
import TextField from './TextField';
import SelectField from './SelectField';
import { showNotification } from './../../../utils';

const Form = React.memo((props) => {
    if (props.item == null) {
        return null;
    }

    let bullet1 = null;
    if (props.item.bullet1) {
        bullet1 = <li>{props.item.bullet1}</li>;
    }

    let bullet2 = null;
    if (props.item.bullet2) {
        bullet2 = <li>{props.item.bullet2}</li>;
    }

    let bullet3 = null;
    if (props.item.bullet3) {
        bullet3 = <li>{props.item.bullet3}</li>;
    }

    let bullet4 = null;
    if (props.item.bullet4) {
        bullet4 = <li>{props.item.bullet4}</li>;
    }

    let bullet5 = null;
    if (props.item.bullet5) {
        bullet5 = <li>{props.item.bullet5}</li>;
    }

    let bullet6 = null;
    if (props.item.bullet6) {
        bullet6 = <li>{props.item.bullet6}</li>;
    }

    let bullet7 = null;
    if (props.item.bullet7) {
        bullet7 = <li>{props.item.bullet7}</li>;
    }

    let bullet8 = null;
    if (props.item.bullet8) {
        bullet8 = <li>{props.item.bullet8}</li>;
    }

    const changeNotesHandler = (event) => {
        props.setNotes(event.target.value);
    };

    const handleSetProduct = (value) => {
        props.history.push('/myuthealth/' + props.type + '/' + value);
    };

    let quantityOptions = [{ value: '', label: 'Select option' }];
    if ([1].includes(parseInt(props.item.id))) {
        quantityOptions.push({ value: 1, label: '1 Bundle (100 pieces)' });
        for (let i = 2; i <= 10; i++) {
            quantityOptions.push({ value: i, label: i + ' Bundles (' + (100 * i) + ' pieces)' });
        }
    } else if ([2, 3].includes(parseInt(props.item.id))) {
        quantityOptions.push({ value: 1, label: '1 Bundle (250 pieces)' });
        for (let i = 2; i <= 10; i++) {
            quantityOptions.push({ value: i, label: i + ' Bundles (' + (250 * i) + ' pieces)' });
        }
    } else if ([4, 5, 6, 7, 8, 12].includes(parseInt(props.item.id))) {
        quantityOptions.push({ value: 1, label: '1 Poster' });
        for (let i = 2; i <= 10; i++) {
            quantityOptions.push({ value: i, label: i + ' Posters' });
        }
    } else if (parseInt(props.item.id) === 9) {
        quantityOptions = [
            { value: '', label: 'Select option' },
            { value: '250', label: '250' },
            { value: '500', label: '500' },
            { value: '1000', label: '1000' },
        ];
    } else if ([13].includes(parseInt(props.item.id))) {
        quantityOptions.push({ value: 1, label: '1 Bundle (250 pieces)' });
        for (let i = 2; i <= 5; i++) {
            quantityOptions.push({ value: i, label: i + ' Bundles (' + (250 * i) + ' pieces)' });
        }
    }

    let productOptions = [];
    let languageField = (
        <SelectField
            required
            label="Language"
            value={props.language}
            setFunction={props.setLanguage}
            options={[
                { value: 'English', label: 'English' },
                { value: 'Spanish', label: 'Spanish' },
                { value: 'Chinese', label: 'Mandarin Chinese' },
                { value: 'Vietnamese', label: 'Vietnamese' },
            ]}
        />
    );
    if (parseInt(props.type) === 1) {
        languageField = (
            <SelectField
                required
                label="Language"
                value={props.language}
                setFunction={props.setLanguage}
                options={[
                    { value: 'English', label: 'English' },
                    { value: 'Spanish', label: 'Spanish' },
                    { value: 'Chinese', label: 'Mandarin Chinese' },
                    { value: 'Vietnamese', label: 'Vietnamese' },
                ]}
            />
        );

        productOptions = [
            { value: '1', label: 'Care Everywhere Tri-fold Brochure' },
            { value: '2', label: 'Take Away Enrollment Card 5x3"' },
            { value: '3', label: 'Always Connected Buckslip 4x9"' },
        ];
    } else if (parseInt(props.type) === 2) {
        if (parseInt(props.product) === 4) {
            languageField = (
                <SelectField
                    required
                    label="Language"
                    value={props.language}
                    setFunction={props.setLanguage}
                    options={[
                        { value: 'English', label: 'English' },
                    ]}
                />
            );
        } else {
            languageField = (
                <SelectField
                    required
                    label="Language"
                    value={props.language}
                    setFunction={props.setLanguage}
                    options={[
                        { value: 'English', label: 'English' },
                        { value: 'Spanish', label: 'Spanish' },
                        { value: 'Chinese', label: 'Mandarin Chinese' },
                        { value: 'Vietnamese', label: 'Vietnamese' },
                    ]}
                />
            );
        }

        productOptions = [
            { value: '4', label: 'Always Connected Adhesive Vinyl Decal 10x4"' },
            { value: '12', label: 'Portal Sign Up Adhesive Vinyl 8.5x11"' },
        ];

        // productOptions = [
        //     { value: '4', label: 'Always Connected Adhesive Vinyl Decal 10x4"' },
        //     { value: '5', label: 'Vinyl Cling Poster 18" x 18"' },
        //     { value: '6', label: 'Laminated Poster 18" x 18"' },
        //     { value: '7', label: 'Laminated Poster 24" x 18"' },
        //     { value: '8', label: 'Foam Board Poster 20" x 30"' },
        // ];
    } else if (parseInt(props.type) === 3) {
        languageField = null;
        productOptions = [
            { value: '9', label: 'SLEEK WRITE RUBBERIZED PEN' },
        ];
    } else if (parseInt(props.type) === 5) {
        languageField = null;
        productOptions = [];
    }

    let clinicOptions = [{ value: '', label: 'Select option' }];
    for (let i = 0; i < props.clinics.length; i++) {
        clinicOptions.push({ value: props.clinics[i].id, label: props.clinics[i].name });
    }

    let selectedLocation = 'Select a Clinic Name';
    for (let i = 0; i < props.locations.length; i++) {
        if (parseInt(props.locationId) === parseInt(props.locations[i].id)) {
            selectedLocation = props.locations[i].name;
            break;
        }
    }

    const handleChangeClinic = (value) => {
        props.setLocationId('');
        props.fetchLocations(value);
        props.setClinicId(value);
    }

    let loadingLocation = null;
    if (props.fetchingLocations) {
        selectedLocation = null;
        loadingLocation = <div className="loading-locations"><i className="fas fa-circle-notch fa-spin" /></div>;
    }

    const handleChangeOtherLocation = (event) => {
        props.setOtherLocation(event.target.checked ? 1 : 0);
    };

    const addToCartHandler = (type = 1) => {
        if (props.quantity === '') {
            return showNotification('Complete Information', 'Enter a quantity', 'info');
        }

        if (parseInt(props.type) !== 4 && parseInt(props.type) !== 5) {
            if ((props.otherLocation && props.clinicName === '') || (!props.otherLocation && props.clinicId === '')) {
                return showNotification('Complete Information', 'Enter a Clinic Name', 'info');
            }

            if (props.otherLocation && props.yourLocation === '') {
                return showNotification('Complete Information', 'Enter your location', 'info');
            }
        }

        if (props.cxmlData.buyer_cookie == null) {
            props.addToCart(1, props.history, type);
        } else {
            props.addToCart(2, props.history, type);
        }
    };

    let buttonLabel = 'Checkout';
    if (props.addingToCart) {
        buttonLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Adding to Cart...</Fragment>;
    }

    let saveWorkLabel = 'Save Work';
    if (props.savingWork) {
        saveWorkLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Saving...</Fragment>;
    }

    let shoppingCartButton = <button type="button" className="add-to-cart" disabled={props.addingToCart} onClick={addToCartHandler.bind(this, 1)}>{buttonLabel}</button>;
    if (props.action === 'edit') {
        shoppingCartButton = null;
    }

    if (parseInt(props.type) === 4) {
        quantityOptions = [
            { value: '', label: 'Select option' },
            { value: 250, label: 250 },
            { value: 500, label: 500 },
            { value: 750, label: 750 },
            { value: 1000, label: 1000 },
        ];

        return (
            <div className="form-container">
                <h5>Description</h5>
                <form action="">
                    <div className="description-section">
                        <div className="mt-3">
                            <b>Title:</b>
                            <br />
                            {props.item.name}
                        </div>
                        <div className="mt-3 mb-3">
                            <b>Description:</b>
                            <br />
                            {props.item.description}
                        </div>
                        <div className="description-list">
                            <div><b>Detail</b></div>
                            <ul>
                                {bullet1}
                                {bullet2}
                                {bullet3}
                                {bullet4}
                                {bullet5}
                                {bullet6}
                                {bullet7}
                                {bullet8}
                            </ul>
                        </div>
                    </div>
                    <SelectField
                        required
                        label="Quantity"
                        value={props.quantity}
                        setFunction={props.setQuantity}
                        options={quantityOptions}
                    />
                    <div className="variable notes-field">
                        <div className="label">Notes:</div>
                        <textarea
                            value={props.notes}
                            onChange={changeNotesHandler}
                        />
                    </div>
                </form>
                <div className="buttons-container">
                    <button type="button" className="continue" onClick={addToCartHandler.bind(this, 2)} disabled={props.savingWork}>{saveWorkLabel}</button>
                    {shoppingCartButton}
                </div>
            </div>
        );
    } else if (parseInt(props.type) === 5) {
        quantityOptions = [{ value: '', label: 'Select option' }];
        quantityOptions.push({ value: 1, label: '1 Bundle (100 pieces)' });
        for (let i = 2; i <= 10; i++) {
            quantityOptions.push({ value: i, label: i + ' Bundles (' + (100 * i) + ' pieces)' });
        }

        let languageSelect = (
            <SelectField
                required
                label="Language"
                value={props.language}
                setFunction={props.setLanguage}
                options={[
                    { value: 'English', label: 'English' },
                    { value: 'Spanish', label: 'Spanish' },
                    { value: 'Vietnamese', label: 'Vietnamese' },
                ]}
            />
        );
        if (parseInt(props.item.id) === 11) {
            languageSelect = (
                <SelectField
                    required
                    label="Language"
                    value={props.language}
                    setFunction={props.setLanguage}
                    options={[
                        { value: 'English', label: 'English' },
                        { value: 'Spanish', label: 'Spanish' },
                        { value: 'Vietnamese', label: 'Vietnamese' },
                        { value: 'Chinese', label: 'Chinese' },
                        { value: 'Arabic', label: 'Arabic' },
                    ]}
                />
            );
        }

        return (
            <div className="form-container">
                <h5>Description</h5>
                <form action="">
                    <div className="description-section">
                        <div className="mt-3">
                            <b>Title:</b>
                            <br />
                            {props.item.name}
                        </div>
                        <div className="mt-3 mb-3">
                            <b>Description:</b>
                            <br />
                            {props.item.description}
                        </div>
                        <div className="description-list">
                            <div><b>Detail</b></div>
                            <ul>
                                {bullet1}
                                {bullet2}
                                {bullet3}
                                {bullet4}
                                {bullet5}
                                {bullet6}
                                {bullet7}
                                {bullet8}
                            </ul>
                        </div>
                    </div>
                    {languageSelect}
                    <SelectField
                        required
                        label="Quantity"
                        value={props.quantity}
                        setFunction={props.setQuantity}
                        options={quantityOptions}
                    />
                    <div className="variable notes-field">
                        <div className="label">Notes:</div>
                        <textarea
                            value={props.notes}
                            onChange={changeNotesHandler}
                        />
                    </div>
                </form>
                <div className="buttons-container">
                    <button type="button" className="continue" onClick={addToCartHandler.bind(this, 2)} disabled={props.savingWork}>{saveWorkLabel}</button>
                    {shoppingCartButton}
                </div>
            </div>
        );
    }

    let favoriteClasses = ['favorite-container'];
    let favoriteIcon = <i className="far fa-heart empty-heart" />;
    if (props.isFavorite) {
        favoriteClasses.push('active');
        favoriteIcon = <i className="fas fa-heart filled-heart" />
    }

    const handleAddFavorite = () => {
        props.addFavorite(props.history);
    };

    let productSelection = (
        <SelectField
            required
            label="Product"
            value={props.product}
            setFunction={handleSetProduct}
            options={productOptions}
        />
    );

    if (parseInt(props.product) === 13) {
        productSelection = null;
        languageField = (
            <SelectField
                required
                label="Language"
                value={props.language}
                setFunction={props.setLanguage}
                options={[
                    { value: 'English', label: 'English' },
                    { value: 'Spanish', label: 'Spanish' },
                ]}
            />
        );
    }

    return (
        <div className="form-container">
            <h5>Please make your selections below.</h5>
            <div className={favoriteClasses.join(' ')} onClick={handleAddFavorite}>
                {favoriteIcon} Favorites
            </div>
            <form action="">
                <hr />
                {productSelection}
                {languageField}
                <SelectField
                    required
                    label="Quantity"
                    value={props.quantity}
                    setFunction={props.setQuantity}
                    options={quantityOptions}
                />
                <hr />
                <h5 className="description-header">Description</h5>
                <div className="description-section">
                    <div>{props.item.description}</div>
                    <div className="description-list">
                        <ul>
                            {bullet1}
                            {bullet2}
                            {bullet3}
                            {bullet4}
                            {bullet5}
                            {bullet6}
                            {bullet7}
                            {bullet8}
                        </ul>
                    </div>
                </div>
                <hr />
                <h5 className="description-header">Shipping Information</h5>
                <SelectField
                    required
                    label="Clinic Name"
                    value={props.clinicId}
                    setFunction={handleChangeClinic}
                    options={clinicOptions}
                    disabled={props.otherLocation}
                />
                <div class="variable">
                    <div class="label">Your Location:</div>
                    <div className="location-address">{selectedLocation}</div>
                </div>
                {loadingLocation}
                <div className="other-field mt-3 mb-2">
                    <input type="checkbox" value={props.otherLocation} checked={props.otherLocation} onClick={handleChangeOtherLocation} /> Other
                </div>
                <TextField
                    label="Clinic Name"
                    value={props.clinicName}
                    setFunction={props.setClinicName}
                    disabled={!props.otherLocation}
                />
                <TextField
                    label="Your Location"
                    value={props.yourLocation}
                    setFunction={props.setYourLocation}
                    placeholder="Address"
                    disabled={!props.otherLocation}
                />
                <div className="variable notes-field">
                    <div className="label">Notes:</div>
                    <textarea
                        value={props.notes}
                        onChange={changeNotesHandler}
                        placeholder={'Please enter your office hours here. \nExample: Mon-Fri 8 AM To 5 PM'}
                    />
                </div>
            </form>
            <div className="buttons-container">
                <button type="button" className="continue" onClick={addToCartHandler.bind(this, 2)} disabled={props.savingWork}>{saveWorkLabel}</button>
                {shoppingCartButton}
            </div>
        </div>
    );
});

export default Form;
